import styled from '@emotion/styled';
import { Subheading, Text } from 'components/Typography';
import { Container, GridItem } from 'components/Layout';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Legend } from 'recharts';
import { ReportGridContainer } from 'components/ReportGridContainer';
import {
    rootChartContainerId,
} from './constants';
import { NotificationSummaryProps } from './types';


export function NotificationSummary({
    chartData,
    reportData,
}: Readonly<NotificationSummaryProps>) {
    return (
        <>
            <ReportGridContainer direction="column">
                <NotificationGridItem>
                    <Subheading>Notification Summary</Subheading>
                </NotificationGridItem>
                <GridItem>
                    <Container spacing={4}>
                        <GridItem>
                            <Text fontWeight="600" color="#bebdbd" fontSize="s">
                                Total Notifications
                            </Text>
                            <Text fontSize="l">{reportData?.mobileCount?.recs}</Text>
                        </GridItem>
                        <GridItem>
                            <Text fontWeight="600" color="#bebdbd" fontSize="s">
                                Total Repairs
                            </Text>
                            <Text fontSize="l">
                                {reportData?.mobileCount?.repairCount}
                            </Text>
                        </GridItem>
                        <GridItem>
                            <Text fontWeight="600" color="#bebdbd" fontSize="s">
                                Total Mobile Number Supplied
                            </Text>
                            <Text fontSize="l">
                                {reportData?.mobileCount?.mobileNumbers}
                            </Text>
                        </GridItem>
                    </Container>
                </GridItem>
            </ReportGridContainer>
            <ChartContainer style={{ height: 150, }} id={rootChartContainerId}>
                <Text fontSize="s" color="#bebdbd">
                    Summary of notifications
                </Text>
                <ResponsiveContainer >
                    <BarChart data={chartData} layout="vertical"   >
                        <CartesianGrid stroke="#ddd" vertical={true} horizontal={false} />
                        <YAxis type="category" dataKey="state" padding-left='30px' />
                        <XAxis type="number" tickCount={11} domain={[0, 'dataMax']} />
                        <Legend
                            layout="horizontal"
                            verticalAlign="top"
                            align="left"
                            iconSize={10}
                            wrapperStyle={{
                                paddingLeft: 20, // Add space between legend and chart
                                paddingTop: 10,  // Add space on top of the legend
                                paddingBottom: 10,
                                justifyContent: 'flex-start',
                                fontSize: 14
                            }}
                        />
                        <Bar dataKey="totalNotifications" fill="#01B8AA" name="Total Notifications" />
                        <Bar dataKey="totalRepairs" fill="#374649" name="Total Repairs" />
                        <Bar dataKey="totalMobileNumberSupplied" fill="#FD625E" name="Total Mobile Number Supplied" />
                    </BarChart>
                </ResponsiveContainer>
            </ChartContainer>
        </>
    );
}


const ChartContainer = styled('div')`
  width: 55vw;
  z-index: 0;
  margin-bottom: ${({ theme }) => theme.padding.xl};
  padding-left: ${({ theme }) => theme.padding.xl};
  background: ${({ theme }) => theme.palette.background.default};
  & .recharts-wrapper {
    padding-bottom: 10px;
  }
  #top-left {
    display: none;
  }
  #top-container {
    .MuiList-root {
      display: flex;
      width: 800px;
  }
  .MuiListItem-root {
      min-width: 200px;
  }
`;

const NotificationGridItem = styled(GridItem)`
  margin-bottom: ${({ theme }) => theme.margin.l};
`;
